export default __webpack_public_path__ + "static/media/Facebook.6b26460a.png";